import type { TableSettingsArgs } from '../server/getTableSettings'
import type { EditableTableSettingsState } from '../shared'

import { getUserSettingsCookie, setUserSettingsCookie } from '../../userSettingsCookie.client'
import { validateTableSettings } from '../shared/helpers'

export const getTableSettingsFromCookie = ({
  pageKey,
  tableSettingsObjectKey,
  defaultTableSettings
}: TableSettingsArgs) => {
  try {
    const cookie = getUserSettingsCookie()

    if (!cookie) {
      return defaultTableSettings
    }

    const tableSettingsObject = cookie[pageKey]?.[tableSettingsObjectKey]

    const validatedTableSettings = validateTableSettings(tableSettingsObject, defaultTableSettings)

    if (validatedTableSettings) {
      return validatedTableSettings
    }

    return defaultTableSettings
  } catch {
    return defaultTableSettings
  }
}

export const setTableSettingsInCookie = ({
  pageKey,
  tableSettingsObjectKey,
  defaultTableSettings,
  key,
  valueToStore
}: TableSettingsArgs & {
  key: keyof EditableTableSettingsState
  valueToStore: EditableTableSettingsState[keyof EditableTableSettingsState]
}) => {
  try {
    const currentTableSettings = getTableSettingsFromCookie({
      pageKey,
      tableSettingsObjectKey,
      defaultTableSettings
    })

    const newSettings = {
      ...currentTableSettings,
      [key]: valueToStore
    }

    setUserSettingsCookie([pageKey, tableSettingsObjectKey], newSettings)
  } catch {
    // Best-effort persistence: ignore cookie write failures.
  }
}
